<template>
  <v-container>
    <PaginatedTable
      id="locacoes"
      ref="table"
      title="Locações"
      :headers="cabecalho"
      :data-fetcher="api.locacoes.indexar"
      sort-by="codigo"
      sort-desc
    >
      <template v-slot:append-title>
        <v-btn @click="handleClickNovaLocacao()" color="primary">
          Nova locação
        </v-btn>
      </template>

      <template v-slot:advancedFilters="{ advancedFilters, refresh, clear }">
        <v-chip-group>
          <v-chip @click="clear()">
            <v-icon small>mdi-filter-off</v-icon>
            Limpar
          </v-chip>

          <AdvancedFilterChip label="Número" :active="!!advancedFilters.codigo">
            <v-text-field
              v-model="advancedFilters.codigo"
              label="Número da locação"
              @keyup.enter="refresh()"
              @click:clear="refresh()"
              clearable
              autofocus
            ></v-text-field>
          </AdvancedFilterChip>

          <AdvancedFilterChip
            label="Cliente"
            :active="!!advancedFilters.cliente"
          >
            <v-text-field
              v-model="advancedFilters.cliente"
              label="Cliente"
              @keyup.enter="refresh()"
              @click:clear="refresh()"
              clearable
              autofocus
            ></v-text-field>
          </AdvancedFilterChip>

          <AdvancedFilterChip
            label="Status"
            :active="
              advancedFilters.status && advancedFilters.status.length > 0
            "
          >
            <v-checkbox
              v-for="estado in estadosLocacao"
              :key="estado.id"
              v-model="advancedFilters.status"
              :label="estado.nome"
              :value="estado.id"
              @change="refresh()"
              multiple
              hide-details
            ></v-checkbox>
          </AdvancedFilterChip>

          <AdvancedFilterChip
            label="Pagamento"
            :active="
              advancedFilters.pagamento && advancedFilters.pagamento !== 'todos'
            "
          >
            <v-radio-group
              v-model="advancedFilters.pagamento"
              @change="refresh()"
            >
              <v-radio label="Todos" value="todos"></v-radio>
              <v-radio label="Pago" value="pago"></v-radio>
              <v-radio label="Não pago" value="nao_pago"></v-radio>
            </v-radio-group>
          </AdvancedFilterChip>

          <AdvancedFilterChip
            label="Data"
            :active="advancedFilters.data_inicio || advancedFilters.data_fim"
          >
            <v-text-field
              label="Data início"
              v-model="advancedFilters.data_inicio"
              @change="refresh()"
              @click:clear="refresh()"
              type="date"
              clearable
            ></v-text-field>
            <v-text-field
              label="Data fim"
              v-model="advancedFilters.data_fim"
              @change="refresh()"
              @click:clear="refresh()"
              type="date"
              clearable
            ></v-text-field>
          </AdvancedFilterChip>
        </v-chip-group>
      </template>

      <template v-slot:item.codigo="{ item }">
        <RouterLink
          :to="{
            name: 'locacoes_locacao_page',
            params: { codigo: item.codigo }
          }"
        >
          {{ item.codigo }}
        </RouterLink>
      </template>

      <template v-slot:item.total="{ item }">
        {{ formatMoney(item.total) }}
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip
          small
          label
          dark
          :color="
            buscarStatusLocacaoPorId(item.status.id)
              ? buscarStatusLocacaoPorId(item.status.id).cor
              : 'grey'
          "
          v-text="item.status.nome"
        ></v-chip>
      </template>

      <template v-slot:item.pago_em="{ item }">
        <span v-if="item.aberto || item.cancelado_em">---</span>
        <v-chip v-else-if="item.pago_em" small color="success" dark label>
          Pago
        </v-chip>
        <v-chip v-else small color="warning" dark label>
          Pendente
        </v-chip>
      </template>
    </PaginatedTable>

    <NovaLocacaoDialog
      titulo="Escolha o cliente"
      ref="nova_locacao_dialog"
      @locacaoAberta="handleLocacaoAberta"
    ></NovaLocacaoDialog>
  </v-container>
</template>

<script>
import api from "@/services/locacoes.js";
import MoneyMixin from "@/mixins/MoneyMixin.js";
import EstadosLocacaoMixin from "@/mixins/locacoes/EstadosLocacaoMixin";
import alerts from "@/mixins/alerts.js";
import NovaLocacaoDialog from "@/components/locacoes/locacoes/NovaLocacaoDialog.vue";
import PaginatedTable from "@/components/server/PaginatedTable.vue";
import AdvancedFilterChip from "@/components/server/advancedFilters/AdvancedFilterChip.vue";

export default {
  mixins: [alerts, MoneyMixin, EstadosLocacaoMixin],

  components: {
    NovaLocacaoDialog,
    PaginatedTable,
    AdvancedFilterChip
  },

  data() {
    return {
      api,
      locacoes: [],
      carregando: false,
      cabecalho: [
        { text: "Número", value: "codigo", width: 150 },
        { text: "Cliente", value: "nome_cliente" },
        { text: "Data", value: "created_at" },
        { text: "Status", value: "status", sortable: false },
        { text: "Pagamento", value: "pago_em" },
        { text: "Total", value: "total" }
      ],
      cadastrandoLocacao: false
    };
  },

  methods: {
    async handleClickNovaLocacao() {
      this.cadastrandoLocacao = true;

      try {
        const locacao = await api.locacoes.iniciar();
        this.handleLocacaoAberta(locacao);
      } catch (error) {
        alert("Não foi possível cadastrar locação");
      } finally {
        this.cadastrandoLocacao = false;
      }
    },

    async handleLocacaoAberta(locacao) {
      this.$router.push({
        name: "locacoes_locacao_page",
        params: {
          codigo: locacao.codigo
        }
      });
    },

    async carregarLocacoes() {
      this.carregando = true;
      this.locacoes = [];
      try {
        this.locacoes = await api.locacoes.indexar();
      } catch (error) {
        console.error(error);
      } finally {
        this.carregando = false;
      }
    }
  }
};
</script>
